import { actionWordPressAddContents } from "../data/action"
import { getContents } from "../data/repository"

/**
 * find candidates for live contents
 * @param {object} state
 * @returns {string[]}
 */
const collectLiveContentIds = (state)=>{
    const {
        config = {},
        live = {},
    } = state;
    if(
        typeof config.livePostsNumberOfItems === typeof 1
        &&
        typeof live.pageviews === typeof {}
        &&
        typeof live.pageviews.content_id === typeof []
    ){
        const numberOfLiveContents = config.livePostsNumberOfItems
        return live
            .pageviews
            .content_id
            .filter((_,index)=> index < numberOfLiveContents)
            .map(({key})=>key);
    }
    return [];
}

/**
 * find candidates for query content_ids
 * @param {object} state
 * @returns {string[]}
 */
const collectQueryContentIds = (state) => {
    const {
        query = {},
    } = state
    let ids = []
    const queries = Object.values(query);
    for( let result of queries){
        const {
            value = []
        } = result
        if(!Array.isArray(value) || value.length < 1) continue;
        if(value[0].content_id){
            ids = [
                ...ids,
                ...value.map(({content_id}) => content_id)
            ]
        }
    }
    return [...(new Set(ids))]
}

/**
 * filter only the ids that are not already in store
 * @param {object} state
 * @param {string[]} candidateIds
 */
const filterMissingIds = (state, candidateIds)=>{
    const {
        wordpress = {},
    } = state
    const existingIds = Object.keys(wordpress)
    return candidateIds.filter(id => !existingIds.includes(id))
}

/**
 * fetch missing contents
 * @param {object} store
 */
const fetch = async (store)=>{
    const state = store.getState()

    const liveCandidates = collectLiveContentIds(state)
    const queryCandidates = collectQueryContentIds(state)

    const candidateIds = [
        ...liveCandidates,
        ...queryCandidates,
    ]

    const uniqueCandidates = [
        ...(new Set(candidateIds)),
    ]

    const missingIds = filterMissingIds(
        state,
        uniqueCandidates
    )

    // -------------------------------------
    // fetch the contents
    // -------------------------------------
    if(missingIds.length){
        const contents = await getContents(missingIds)
        if(contents.length){
            store.dispatch(actionWordPressAddContents(contents))
        }
    }
}

/**
 * automatically fetch every timeout
 * @param {object} store
 */
const autoStartFetching = (store, seconds)=>{
    clearTimeout(timeoutId)
    timeoutId = setTimeout(async ()=>{
        await fetch(store)
        autoStartFetching(store, seconds)
    }, 3000 * seconds)
}
let timeoutId = null

/**
 * automatically fetch contents
 * @param {object} store redux store
 */
export const autoWordPress = (store)=>{
    autoStartFetching(store, 1)
}